import React from 'react';

import '../App.css';
import '../scss/main.scss';
import { addLoadingIcon, hideLoadingIcon, translate } from '../utils';
import main from '../img/main.png';

import en from '../languages/en.json';
import ru from '../languages/ru.json';
import be from '../languages/be.json';
// components
import Header from './controls-header/Header';
import Weather from './weather/Weather';
import Map from './map/Map';
import MainImage from './MainImage';

import City from './weather/City';
import Time from './weather/Time';
import Conditions from './weather/Conditions';
import Cloud from './weather/Cloud';
import Temperature from './weather/Temperature';

export default class App extends React.Component {
  constructor(props) {
    super();
    this.getSearchCity = this.getSearchCity.bind(this);
    this.changeTemperature = this.changeTemperature.bind(this);
    this.changeImage = this.changeImage.bind(this);
    this.getMainImage = this.getMainImage.bind(this);
    this.getLanguageDayWeeks = this.getLanguageDayWeeks.bind(this);
    this.state = {
      city: props.data,
      weather: {},
      isLoading: true,
      temperature: '',
      degree: this.getLocalUnitsDegree(),
      image: '',
      season: undefined,
      timesOfday: '',
      language: this.getLocalUserLang(),
      langDayWeeks: this.getLocalUserDay(),
      langDayWeeksShort: this.getLocalUserDayShort(),
      langDayMonth: this.getLocalUserMonth(),
    };
  }

  async componentDidMount() {
    await this.getWeather();
    this.changeSaveUserLang();
    this.getMainImage();
  }

  getSearchCity(citySearch) {
    this.setState({ city: citySearch }, () => this.getWeather());
    this.getMainImage();
  }

  getLocalUnitsDegree() {
    this.degreeLocal = localStorage.getItem('degreeLocal');
    this.system = this.degreeLocal || 'M';
    return this.system;
  }

  getLocalUserLang() {
    this.userLang = localStorage.getItem('userLang');
    this.lang = this.userLang || 'en';
    return this.lang;
  }

  getLocalUserDay() {
    this.userDayLang = JSON.parse(localStorage.getItem('userDayLang'));
    const day = {
      0: 'monday',
      1: 'tuesday',
      2: 'wednesday',
      3: 'thursday',
      4: 'friday',
      5: 'saturday',
      6: 'sunday',
    };
    this.dayLang = this.userDayLang || day;
    return this.dayLang;
  }

  getLocalUserDayShort() {
    this.langDayWeeksShort = JSON.parse(
      localStorage.getItem('langDayWeeksShort')
    );
    const day = {
      0: 'Mon',
      1: 'Tue',
      2: 'Wed',
      3: 'Thu',
      4: 'Fri',
      5: 'Sat',
      6: 'Sun',
    };
    this.dayLang = this.langDayWeeksShort || day;
    return this.dayLang;
  }

  getLocalUserMonth() {
    this.langDayMonth = JSON.parse(localStorage.getItem('langDayMonth'));
    const month = {
      0: 'January',
      1: 'February',
      2: 'March',
      3: 'April',
      4: 'May',
      5: 'June',
      6: 'July',
      7: 'August',
      8: 'September',
      9: 'October',
      10: 'November',
      11: 'December',
    };
    this.monthLang = this.langDayMonth || month;
    return this.monthLang;
  }

  async getMainImage() {
    addLoadingIcon();
    const { season, timesOfday } = this.state;
    if (season !== undefined) {
      try {
        const resImg = await fetch(
          `https://api.unsplash.com/photos/random?orientation=landscape&per_page=1&query=${season}+${timesOfday}&client_id=ODhUGbfYzNmZOGTSZAw1ntgW5QrjF5xqvz0BcZmsVSY`
        );

        const url = await resImg.json();
        this.setState({ image: url.urls.full });
        global.console.log(
          `Request for img. Season: "${season}"; Day of time: "${timesOfday}"`
        );
      } catch {
        global.console.log(
          `Request for img. Season: "${season}"; Day of time: "${timesOfday}"`
        );
        this.setState({ image: main });
      }
    }
    hideLoadingIcon();
  }

  async getWeather() {
    addLoadingIcon();
    try {
      const { city, degree, language } = this.state;

      const resCity = await fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${city}?&key=d4e2016e1d404d61a925f6d1b6bcbb6f&language=${language}`
      );
      const dataCity = await resCity.json();

      // get weather today
      const resWeatherToday = await fetch(
        `https://api.weatherbit.io/v2.0/current?&lat=${dataCity.results[0].geometry.lat}&lon=${dataCity.results[0].geometry.lng}&key=f6c5389e0a7147a6b0edce8b817d7fcb&units=${degree}`
      );
      const dataWeatherToday = await resWeatherToday.json();

      // get weather 3 day
      const resWeather = await fetch(
        `https://api.weatherbit.io/v2.0/forecast/daily?&lat=${dataCity.results[0].geometry.lat}&lon=${dataCity.results[0].geometry.lng}&key=f6c5389e0a7147a6b0edce8b817d7fcb&lang=en&units=${degree}`
      );

      const dataWeather = await resWeather.json();

      const cityWeather = {
        geometry: dataCity.results[0].geometry,
        city: dataCity.results[0].formatted,
        weather: dataWeather.data,
        weatherToday: dataWeatherToday.data[0],
        timestamp: dataWeatherToday.data[0].timezone,
      };
      this.setState({
        weather: cityWeather,
        isLoading: false,
        temperature: cityWeather.weatherToday.temp,
      });
      // this.getMainImage();
    } catch {
      global.window.alert('Please write correct city name');
    }
    hideLoadingIcon();
  }

  getLanguageDayWeeks(datalang, datalangShort, monthLang, lang) {
    localStorage.setItem('userLang', lang);
    localStorage.setItem('userDayLang', JSON.stringify(datalang));
    localStorage.setItem('langDayWeeksShort', JSON.stringify(datalangShort));
    localStorage.setItem('langDayMonth', JSON.stringify(monthLang));
    this.setState(
      {
        langDayWeeks: datalang,
        langDayWeeksShort: datalangShort,
        language: lang,
        langDayMonth: monthLang,
      },
      () => this.getWeather()
    );
  }

  changeSaveUserLang() {
    const { language } = this.state;
    switch (language) {
      case 'ru':
        translate(ru);
        break;
      case 'en':
        translate(en);
        break;
      case 'be':
        translate(be);
        break;
      default:
        break;
    }
  }

  changeImage(resSeason, resTimesOfday) {
    this.setState({ season: resSeason, timesOfday: resTimesOfday });
  }

  changeTemperature(expression, system) {
    this.setState({ temperature: expression, degree: system }, () =>
      this.getWeather()
    );
    localStorage.setItem('degreeLocal', system);
  }

  render() {
    const {
      weather,
      isLoading,
      error,
      temperature,
      degree,
      image,
      language,
      langDayWeeks,
      langDayWeeksShort,
      langDayMonth,
    } = this.state;

    if (isLoading) return 'Loading...';
    if (error) return 'error';
    if (weather)
      return (
        <div className="App">
          <div className="img-wrapper">
            <MainImage image={image} />
          </div>

          <div className="app-wrapper">
            <Header
              data={{
                getSearchCity: this.getSearchCity,
                changeTemperature: this.changeTemperature,
                weather: weather.weatherToday,
                getMainImage: this.getMainImage,
                getLanguageDayWeeks: this.getLanguageDayWeeks,
                lang: language,
                deg: degree,
              }}
            />

            <div className="main-wrapper">
              <div className="weather">
                <City name={weather.city} />

                <div className="day">
                  <Time
                    info={{
                      timestamp: weather.timestamp,
                      changeImage: this.changeImage,
                      langDay: langDayWeeksShort,
                      langMonth: langDayMonth,
                    }}
                  />
                </div>
                <div className="weather-today">
                  <Temperature
                    info={{
                      temp: temperature,
                      class: 'temperature',
                    }}
                  />
                  <Cloud
                    info={{
                      icon: weather.weather[0].weather.icon,
                      class: 'cloud',
                    }}
                  />
                  <Conditions info={weather.weatherToday} />
                </div>

                <Weather
                  info={{
                    weather: weather.weather,
                    lang: langDayWeeks,
                  }}
                />
              </div>

              <Map geometry={weather.geometry} />
            </div>
          </div>
        </div>
      );
  }
}
